import { DialogLocal } from "@/components/Dialog";
import { GetCancelsOrderDailyCount } from "@/types/Api/Market/Order/getCancelsOrderDailyCount";

export const dialogUploadPaidCertification = () => {
  DialogLocal({
    title: "提示",
    content: <div style={{ textAlign: "center" }}>请上传付款凭证</div>,
  });
};

export const dialogConfirmPaid = (cb: Function) => {
  DialogLocal({
    title: "是否已转账",
    cancelText: "取消",
    content: (
      <>
        请再次确认您已使用实名认证账户成功转账， 如发现有违规操作可能会面临
        <span style={{ color: "#FB2222" }}>「永久封号」</span>
        处理
      </>
    ),
    async onConfirm() {
      cb();
      return true;
    },
  });
};

export const dialogConfirmCancelTrading = (
  {
    allowedCancelsOrderDailyCount,
    cancelsOrderDailyCount,
  }: GetCancelsOrderDailyCount["response"],
  cb: Function
) => {
  DialogLocal({
    title: "您确定取消该笔交易",
    cancelText: "取消",
    content: (
      <div>
        <div style={{ fontWeight: 600 }}>提示：</div>
        {/* <div>1.如果您已给卖方付款，请勿取消交易；</div> */}
        <div>
          1.如果您在一天内取消
          <span style={{ color: "#FB2222" }}>
            {allowedCancelsOrderDailyCount}次
          </span>
          买卖订单，当天您的账户将会被禁止买卖。
        </div>
        <div>2.如果因为您的收款账户异常，无法创建订单，请拒绝后联系在线客服为您暂停挂单</div>
        <div style={{ textAlign: "center" }}>
          今日还可取消
          <span style={{ color: "#FB2222" }}>
            {allowedCancelsOrderDailyCount - cancelsOrderDailyCount}次
          </span>
          挂单，请谨慎操作
        </div>
      </div>
    ),
    async onConfirm() {
      cb();
      return true;
    },
  });
};
